import { resetMailingRuleModeAction } from 'modules/mailingRuleModeNavigation';
import { resetStrategyModeAction } from 'modules/strategyModeNavigation';
import { MAILING_CONTAINERS_LIST } from 'shared/enums';

export const clearNavigationActions = {
  [MAILING_CONTAINERS_LIST.MAILING_RULES]: resetMailingRuleModeAction,
  [MAILING_CONTAINERS_LIST.MAILING_STRATEGIES]: resetStrategyModeAction,
};
